// extracted by mini-css-extract-plugin
module.exports = {"social-media-item":"SocialMediaItem_social-media-item__PTIRB"};